import { Box, Container } from "@mui/material";

import { colors } from "theme";

import { MutationList } from "components/MutationList";
import { TargetList } from "./TargetList";

export const NextGeneration = () => (
  <Box component="section" bgcolor={colors.white} pb={{ xs: 4, md: 7 }}>
    <Container>
      <Box
        maxWidth={{ xs: "unset", sm: 440, md: "unset" }}
        margin="auto"
        position="relative"
        pt={{ xs: 77, sm: 74.375, md: 20.5, lg: 19.875 }}
      >
        <Box
          position="absolute"
          top={{ xs: -175, sm: -230, md: -162, lg: -167 }}
          left={0}
          right={0}
        >
          <TargetList />
        </Box>
        <MutationList />
      </Box>
    </Container>
  </Box>
);
